import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import AppRouter from './router/index';
import 'assets/styles/index.less';
import flexView from './utils/rem';
import './i18n';

flexView();

ReactDOM.render(
  <Provider store={store}>
    <AppRouter />
  </Provider>,
  document.getElementById('root'),
);
